export default function DisableContextMenu() {
  window.oncontextmenu = (event: any) => {
    event.preventDefault();
    event.stopPropagation();

    return false;
  };
}
